import type { ComponentProps } from 'react';
import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { TypedTranslate } from '@change-corgi/core-react/i18n';

import { useBadgeScore } from './hooks/useBadgeScore';

type BadgeScoreProps = ComponentProps<'div'> & { score: number; smallText?: boolean };

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const BadgeScore: React.FC<BadgeScoreProps> = ({ score, smallText, ...rest }) => {
	const {
		data: { labelKey, color, backgroundColor },
	} = useBadgeScore(score);
	return (
		<div className="text-typography-strong flex items-center gap-4" {...rest}>
			<div data-qa="score-container" className="grid min-w-[72px] place-items-center">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 16 16"
					fill={backgroundColor}
					className="col-[1/-1] row-[1/-1]"
				>
					<path d="M7.5.29a1 1 0 0 1 1 0l5.93 3.42c.3.18.5.51.5.87v6.84a1 1 0 0 1-.5.87L8.5 15.7a1 1 0 0 1-1 0L1.57 12.3a1 1 0 0 1-.5-.87V4.58a1 1 0 0 1 .5-.87L7.5.3Z" />
				</svg>
				<Text
					as="span"
					fontWeight="bold"
					className="col-[1/-1] row-[1/-1]"
					style={{ color, fontSize: 24, lineHeight: '40px' }}
				>
					{score}
				</Text>
			</div>
			<Text as="span" id="score-text" data-qa="score-text" className="min-w-0 flex-1 break-words">
				<TypedTranslate value={labelKey} />
			</Text>
		</div>
	);
};
